import React from "react";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import Footer from "../../components/Footer";

const GeorgiaMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Georgia</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">
              MD (Doctor of Medicine) — equivalent to MBBS in India
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">6 years (includes clinical rotations)</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks in PCB</li>
              <li>Must qualify NEET (for Indian students)</li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">English</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">NMC (India), WHO, ECFMG (USA), WFME</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Advantages:</h3>
            <p className="detail-text">
              No donation fees, European lifestyle, globally accepted degree.
            </p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top Medical Universities in Georgia
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Tbilisi State Medical University (TSMU), Tbilisi
              </h3>
              <p className="university-description">
                Oldest and most prestigious medical university in Georgia. Fully
                NMC and WHO recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Ivane Javakhishvili Tbilisi State University (TSU), Tbilisi
              </h3>
              <p className="university-description">
                One of the largest public universities in Georgia. Offers
                globally recognized MD program.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Batumi Shota Rustaveli State University, Batumi
              </h3>
              <p className="university-description">
                Government university with strong clinical training. Affordable
                and popular among Indian students.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">European University, Tbilisi</h3>
              <p className="university-description">
                Modern infrastructure and clinical tie-ups. Offers
                English-taught MBBS/MD programs.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                New Vision University, Tbilisi
              </h3>
              <p className="university-description">
                Recognized by NMC and WHO. Well-equipped hospitals for clinical
                practice.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Georgian American University (GAU), Tbilisi
              </h3>
              <p className="university-description">
                American curriculum influence. Offers English-medium MD degree.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                David Tvildiani Medical University (DTMU), Tbilisi
              </h3>
              <p className="university-description">
                Known for academic excellence and USMLE-oriented teaching. High
                FMGE pass rate among Indian students.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Caucasus International University (CIU), Tbilisi
              </h3>
              <p className="university-description">
                Good academic infrastructure. NMC and WHO recognized.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default GeorgiaMbbs;
